import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {throwError as observableThrowError,  Observable, of as observableOf } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { ICoupons } from '../interfaces/coupons';
import { ICoupon } from '../interfaces/coupon';
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CouponService {

  constructor(private _apiService: ApiService) { }

  search(arr: any) : Observable<ICoupons>  {
    let urlParams = new HttpParams()
    for(let i in arr) {
      urlParams = urlParams.set(i, arr[i].toString())
    }

    //urlParams = urlParams.set('sort', sort)
    //urlParams = urlParams.set('direction', direction)
    //urlParams = urlParams.set('page', page.toString())

    return this._apiService.doGET('coupons', urlParams)
      .pipe(catchError(err => {
        return observableThrowError(err.error_message)
      }))
  }

  show(id: number) : Observable<ICoupon>  {
    return this._apiService.doGET('coupon/'+id)
      .pipe(catchError(err => {
        return observableThrowError(err.error_message)
      }))
  }

  store(data) : Observable<any> {
    return this._apiService.doPOST('coupons', data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  patch(idcupom, data) : Observable<any> {
    return this._apiService.doPATCH('coupon/'+idcupom, data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  delete(idcupom) : Observable<any> {
    return this._apiService.doDELETE('coupon/'+idcupom)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }
}
